import * as React from "react";
import { CompoCategoriesClient } from "../../../src/entity/CompoCategoriesClient";
import { SmallButton } from "../DesignSystem/SmallButton";
import { Entry } from "../models/entries";
import { EntryFinalResults } from "../models/entryfinalresults";
import { UserJSON } from "../models/users";
import { GoldCoin } from "../Toolbar/GoldCoin";
import {
  ChartBarIcon,
  TrophyIcon,
} from "@heroicons/react/24/solid";

export function EntryResultsWidget({
  entry,
  user,
  category_names,
  results,
}: {
  entry: Entry;
  user: UserJSON | undefined;
  category_names: CompoCategoriesClient;
  results: EntryFinalResults;
}): JSX.Element {
  if (!results) {
    return <div></div>;
  }

  const groupings: {
    name: string;
    score: number;
    bar: number;
    placement: number;
  }[] = [];

  for (let i = 0; i < category_names.list.length; i++) {
    groupings.push({
      name: category_names.list[i],
      score: (results as any)[`category_${i + 1}`],
      bar: ((results as any)[`category_${i + 1}`] * 100) / 5,
      placement: (results as any)[`category_${i + 1}_standing`],
    });
  }

  groupings.sort((a, b) => a.placement - b.placement);

  return (
    <div>
      {entry.hidden ? (
        <div>
          <span>
            {" "}
            This entry did not qualify to receive results since its author did
            not vote :({" "}
          </span>

          {user && user.id === entry.user_id ? (
            <div>
              However, you may buy your results on this song for 10 <GoldCoin />
              ! Contact johnfn on Discord.
            </div>
          ) : undefined}
        </div>
      ) : (
        <div className="rounded-2xl border border-slate-200 bg-white/90 px-6 py-5 shadow-sm backdrop-blur-sm dark:border-slate-700 dark:bg-slate-800 dark:shadow-none">
          <h3 className="mb-4 text-2xl font-bold text-slate-800 dark:text-white">
            Results
          </h3>
          <div className="space-y-3">
            {groupings.map(({ name, score, bar, placement }) => (
              <div key={name} className="flex items-center gap-3">
                <span className="w-[100px] text-xs font-medium uppercase tracking-wide text-slate-400 dark:text-slate-500">
                  {name}
                </span>
                <span className="w-[45px] text-right text-sm text-slate-600 dark:text-slate-300">
                  {score.toFixed(2)}
                </span>
                <div className="relative h-2 flex-1 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-yellow-300 to-green-400"
                    style={{ width: `${bar}%` }}
                  />
                </div>
                <span className="w-[36px] text-right text-sm text-slate-500 dark:text-slate-400">
                  #{placement}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-4 flex flex-wrap gap-2 border-t border-slate-200 pt-4 dark:border-slate-700">
            <SmallButton
              to={`/entry/${entry.id}/stats`}
              icon={<ChartBarIcon className="h-4 w-4" />}
            >
              See stats
            </SmallButton>
            <SmallButton
              to={`/compo/${entry.compo_id}/results`}
              icon={<TrophyIcon className="h-4 w-4" />}
            >
              See compo results
            </SmallButton>
          </div>
        </div>
      )}
    </div>
  );
}
